module.exports = "<nav class=\"navbar navbar-sidebar\">\n  <ul class=\"nav sidebar-nav\">\n    <li *ngFor=\"let page of pages\" [class.hidden]=\"!(page.roles.indexOf(user.role) != -1)\">\n      <a routerLink=\"{{ page.link }}\"\n        routerLinkActive=\"is-active\">\n        {{ page.title | translate }}\n      </a>\n    </li>\n  </ul>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/menu/menu.component.html
// module id = ./src/app/shared/menu/menu.component.html
// module chunks = main